const USER_ALREADY_EXISTS_PROBLEM =
  'https://gomercatus.com/problems/admin/users/user-already-exists'
const USER_NOT_CREATED_PROBLEM = 'https://gomercatus.com/problems/admin/users/user-not-created'
const LICENSE_LIMIT_EXCEEDED_PROBLEM =
  'https://gomercatus.com/problems/admin/users/license-limit-exceeded'
const ORGANIZATION_BUSY_PROBLEM = 'https://gomercatus.com/problems/admin/orgs/organization-busy'
const DUPLICATE_ORGANIZATION_PROBLEM =
  'https://gomercatus.com/problems/admin/orgs/duplicate-organization'
const INVALID_DBT_JOB_ID_PROBLEM = 'https://gomercatus.com/problems/admin/orgs/invalid-dbt-job-id'
const USER_LIMIT_BELOW_ACTIVE_USERS_PROBLEM =
  'https://gomercatus.com/problems/admin/orgs/user-limit-below-active-users'

function hasProblemType(error: unknown, type: string) {
  const axiosError = error as { response?: { data?: { type?: string } } }
  return axiosError.response?.data?.type === type
}

/** True when the organization already has a user with the new user's email address. */
export function isUserAlreadyExists(error: unknown) {
  return hasProblemType(error, USER_ALREADY_EXISTS_PROBLEM)
}

/**
 * True when the server could not create a user because another organization's user has the email
 * address. The problem deliberately doesn't say so, and neither may the message shown for it.
 */
export function isUserNotCreated(error: unknown) {
  return hasProblemType(error, USER_NOT_CREATED_PROBLEM)
}

/**
 * True when the server refused to create, activate or re-license a user because the organization
 * already has as many active users of that license type as it is allowed.
 */
export function isLicenseLimitExceeded(error: unknown) {
  return hasProblemType(error, LICENSE_LIMIT_EXCEEDED_PROBLEM)
}

/** True when another user write held the organization's lock beyond its bounded wait. */
export function isOrganizationBusy(error: unknown) {
  return hasProblemType(error, ORGANIZATION_BUSY_PROBLEM)
}

/** True when the organization's unique ID collides with an existing organization's. */
export function isDuplicateOrganization(error: unknown) {
  return hasProblemType(error, DUPLICATE_ORGANIZATION_PROBLEM)
}

/** True when the organization's DBT job ID doesn't match the expected `<name>:<id>` format. */
export function isInvalidDbtJobId(error: unknown) {
  return hasProblemType(error, INVALID_DBT_JOB_ID_PROBLEM)
}

/**
 * True when the server refused to lower the organization's Power user limit below its current
 * number of active Power-licensed users.
 */
export function isUserLimitBelowActiveUsers(error: unknown) {
  return hasProblemType(error, USER_LIMIT_BELOW_ACTIVE_USERS_PROBLEM)
}
